import { useCallback, useEffect, useRef, useState } from 'react';
import { api } from '../context/AuthContext';

const SEITE = 50;
const LEER = { total: 0, gesamt: 0, counts: { mandat: {}, zugang: {} }, abgelaufen_gesamt: 0 };

export const useAdminUsers = ({ search, mandat, zugang }) => {
  const [users, setUsers] = useState([]);
  const [meta, setMeta] = useState(LEER);
  const [laden, setLaden] = useState(false);
  const anfrage = useRef(0);

  const load = useCallback(async (skip = 0) => {
    const nr = ++anfrage.current;
    setLaden(true);
    try {
      const { data } = await api.get('/admin/users', { params: { q: search || '', mandat, zugang, skip, limit: SEITE } });
      if (nr !== anfrage.current) return;
      setUsers((prev) => (skip ? [...prev, ...data.items] : data.items));
      setMeta(data);
    } finally {
      if (nr === anfrage.current) setLaden(false);
    }
  }, [search, mandat, zugang]);

  useEffect(() => {
    const t = setTimeout(() => { load(0).catch(() => {}); }, 300);
    return () => clearTimeout(t);
  }, [load]);

  const reload = useCallback(() => load(0).catch(() => {}), [load]);
  const loadMore = useCallback(() => load(users.length).catch(() => {}), [load, users.length]);
  return { users, setUsers, meta, laden, reload, loadMore, hatMehr: users.length < meta.total };
};
